import { render, staticRenderFns } from "./helpPage.vue?vue&type=template&id=35d6c803&scoped=true&"
import script from "./helpPage.vue?vue&type=script&lang=js&"
export * from "./helpPage.vue?vue&type=script&lang=js&"
import style0 from "./helpPage.vue?vue&type=style&index=0&id=35d6c803&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d6c803",
  null
  
)

export default component.exports